import { hysteriFetch, wrappers } from 'hysterics';

export default async function fetchNLSResults(
	widgetSearchServiceUri,
	siteId,
	locale,
	device,
	pageAlias,
	windowId,
	widgetName,
	query,
	conditionFilter,
	vehicleOrder,
	prioritizeClosestVehicles,
	userPostalCode
) {
	const nlsClientService = hysteriFetch('nlsClientService', {
		[wrappers.circuitBreaker.contextKey]: {
			timeout: 10000
		},
		[wrappers.timeout.contextKey]: {
			timeout: 10000
		},
		[wrappers.retry.contextKey]: {
			retries: 0
		}
	});

	let sortByNewest = true;
	if (vehicleOrder === 'Oldest First') {
		sortByNewest = false;
	}

	const body = {
		siteId,
		locale,
		device,
		pageAlias,
		windowId,
		widgetName,
		listingConfigId: 'auto-new,auto-used',
		facetInstanceId: 'listing',
		shouldReturnCardsAlso: true,
		sortByNewest,
		query,
		conditionFilter
	};

	if (prioritizeClosestVehicles) {
		body.userPostalCode = userPostalCode;
	}

	return nlsClientService(`${widgetSearchServiceUri}/nlInventorySearch`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(body)
	});
}
